import React, {useState, useRef, useEffect} from 'react';
import {Container, Row, Col} from "reactstrap";
import {format} from "react-string-format";
import * as url from "../../api/url";
import {Popover, PopoverBody, PopoverHeader} from "reactstrap";
import {withTranslation} from "react-i18next";
import {apiGetUsersAvatarDetail} from "../../api/calls/users";

const SmallAvatar = (props) => {
  const [show, setShow] = useState(false)
  const [user, setUser] = useState(false)
  const ref = useRef(null)

  const handleClick = () => {
    setShow(!show)
  }

  useEffect(() => {
    if (show) {
      apiGetUsersAvatarDetail({id: props.user, history: props.history}).then((response) => {
        setUser(response.response)
      }).catch(() => {});
    }
  }, [show])

  return (
    <React.Fragment>
      <img ref={ref} className="rounded-circle header-profile-user2" src={format(url.DIRECT_AVATAR, props.user)} alt="Avatar" onClick={handleClick}/>
      {user && <Popover placement="top" isOpen={show} target={ref} fade={true} delay={0}>
        <PopoverHeader>{user.name}</PopoverHeader>
        <PopoverBody>
          <Container>
            <Row>
              <Col className="col-7">
                <img className="rounded-circle small-avatar" src={format(url.DIRECT_AVATAR, props.user)} alt="Avatar"/>
              </Col>
              <Col className="col-5">
                {user.groups.map((group, idx) => (
                  <div key={idx} className="small-avatar-group">
                    {group.name}
                  </div>
                ))}
              </Col>
            </Row>
          </Container>
        </PopoverBody>
      </Popover>}
    </React.Fragment>
  )
}

export default withTranslation()(SmallAvatar);
